type ParaphraseIconProps = {
  color?: string
  width?: string
  height?: string
  testId?: string
}

export const ParaphraseIcon = ({
  width = '17',
  height = '18',
  color = '#534F63',
  testId,
}: ParaphraseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      data-test={testId}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m12.224 1.5 2.716 3m-13.582 12 .867-3.51c.057-.23.085-.344.128-.45.039-.095.086-.185.142-.27.062-.094.138-.178.29-.346l7.017-7.75c.135-.148.202-.223.28-.25a.309.309 0 0 1 .21 0c.077.027.144.102.279.25l1.948 2.152c.134.148.201.223.227.308a.413.413 0 0 1 0 .232c-.026.086-.093.16-.227.308L5.5 14.924a2.964 2.964 0 0 1-.313.321 1.335 1.335 0 0 1-.244.156c-.096.048-.2.08-.407.142l-3.179.957Z"
      />
    </svg>
  )
}
